module.exports = __webpack_public_path__ + "media/Blue-Export.c590e098.webm";